<template>
    <div class="row form-group">
        <div class="col-md-7 col-12">
            <label>{{ text.simulationDate }}</label>
        </div>
        <div class="col-md-5 col-12 text-md-right txt-left">
            <p>{{ medialCareDate | formatDate }}</p>
        </div>
    </div>
</template>

<script>
import resources from '../helpers/resources'

export default {
    data(){
        return {
            text : resources,
            medialCareDate:new Date(),
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/CommonForm.vue